<template>
  <div class="d-flex flex-column">
    <div class="grid-header">
      <h1>{{ $t("operaciones_energia.titulo") }} {{props.nombreCliente}}</h1>
      <div class="toolbar">
      </div>
    </div>

    <DxDataGrid v-bind="gridProperties" :data-source="gridSource" ref="grid"
      class="dx-card wide-card grid-operaciones">
      <DxColumnFixing :enabled="true" />
      <DxColumn data-field="CodigoSecuencial" :caption="$t('operaciones_energia.grid.id')" format="0000000000"></DxColumn>
      <DxColumn v-if="puedoVerAgenteYComision" data-field="NombreAgente" :caption="$t('operaciones_energia.grid.agente')"></DxColumn>
      <DxColumn data-field="Comercializadora" :caption="$t('operaciones_energia.grid.comercializadora')"></DxColumn>
      <DxColumn data-field="TelefonoMovil" :caption="$t('operaciones_energia.grid.telefono_movil')"></DxColumn>
      <DxColumn data-field="TelefonoFijo" :caption="$t('operaciones_energia.grid.telefono_fijo')"></DxColumn>
      <DxColumn data-field="Email" :caption="$t('operaciones_energia.grid.email')"></DxColumn>
      <DxColumn data-field="TipoPersona" :caption="$t('operaciones_energia.grid.tipo_persona')" cell-template="tipoPersonaTemplate">
        <DxLookup v-bind="getLookup('operaciones', 'tipo_persona')"></DxLookup>
      </DxColumn>
      <DxColumn data-field="Direccion" :caption="$t('operaciones_energia.grid.direccion')"></DxColumn>
      <DxColumn data-field="TarifaAccesoLuz" :caption="$t('operaciones_energia.grid.tarifa_de_acceso_luz')"></DxColumn>
      <DxColumn data-field="CupsLuz" :caption="$t('operaciones_energia.grid.cups_luz')"></DxColumn>
      <DxColumn data-field="TarifaAccesoGas" :caption="$t('operaciones_energia.grid.tarifa_de_acceso_gas')"></DxColumn>
      <DxColumn data-field="CupsGas" :caption="$t('operaciones_energia.grid.cups_gas')"></DxColumn>
      <DxColumn data-field="CodigoEstado" :caption="$t('operaciones_energia.grid.estado')" cell-template="estadoTemplate">
        <DxLookup v-bind="getLookup('operaciones', 'estado')"></DxLookup>
      </DxColumn>
      <DxColumn v-if="puedoVerAgenteYComision" data-field="Comision" :caption="$t('cliente_operaciones.grid.comision')" data-type="number">
        <DxFormat v-bind="currencyFormat()"></DxFormat>
      </DxColumn>
      <DxColumn data-field="Retrocomision" :caption="$t('cliente_operaciones.grid.retrocomision')"
        data-type="number" :calculate-cell-value="formatRetrocomision">
        <DxFormat v-bind="currencyFormat()"></DxFormat>
      </DxColumn>
      <DxColumn type="buttons" :caption="$t('operaciones_energia.grid.acciones')" :fixed="true" fixed-position="right" width="100px" :buttons="[
        {
          cssClass: 'btn btn-link text-decoration-none btn-sm',
          text: $t('operaciones_energia.grid.ver_detalle'),
          icon: 'fa-regular fa-magnifying-glass text-success',
          onClick: (e: any) => verDetalle(e)
        }
      ]"/>

      <template #estadoTemplate="{ data }">
        <div :class="[
          `d-inline-block rounded py-1 px-2 `,
          `estado-operacion ${data.value.replace(' ', '')}`,
        ]">
            {{ $t(`operaciones.estado.${data.value}`) }}
        </div>
      </template>
      <template #tipoPersonaTemplate="{ data }">
        <div class="d-flex">
          {{ $t(`operaciones.tipo_persona.${data.value}`) }}
        </div>
      </template>
    </DxDataGrid>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { DxDataGrid, DxColumn, DxColumnFixing, DxLookup, DxFormat } from "devextreme-vue/data-grid";
import { getDefaultGridProperties, getLookup, currencyFormat } from "@helpers/grid-helper";
import { useApi } from "@api/integration";
import CustomStore from "devextreme/data/custom_store";
import { useIntl } from "@services/i18n";
import { useModalService } from "@services/modal-service";
import { useAuthorization } from "@/.shared/services/auth/authorization";
import { PermissionsApp } from "@/.shared/services/auth/authorization/authorization-service-impl";
import type DevExpress from "devextreme";
import { TipoOperacionEnum } from "@/.shared/enums/TipoOperacionEnum";
import { useRouter } from "@/.shared/services/routing-services";

const api = useApi();
const autho = useAuthorization();
const grid = ref<DxDataGrid>();
const gridSource = ref<CustomStore>();
const gridProperties = ref<DxDataGrid>();
const router = useRouter();

const props = defineProps<{
  idCliente: string;
  nombreCliente: string;
}>();

onMounted(async () => {
  gridProperties.value = getDefaultGridProperties();
  gridProperties.value.remoteOperations = false;
  setDataSource();
});

const setDataSource = async () => {
  gridSource.value = new CustomStore({
    key: "IdOperacion",
    load: async () => {
      return (await api.callStandardApi("getOperacionesByIdCliente", { showLoading: false }, props.idCliente)).OperacionesEnergia;
    }
  });
}

const verDetalle = async (data: DevExpress.ui.dxDataGrid.ColumnButtonClickEvent) => {
  await router.push({ name: "tramite", query: { idOperacion: data.row?.data.IdOperacion, tipoOperacion: TipoOperacionEnum.Energia } });
}

const puedoVerAgenteYComision = computed(() => {
  return autho.hasPermission(PermissionsApp.Administracion);
});

const formatRetrocomision = (rowData: any) => {
  return rowData.Retrocomision ? -Math.abs(rowData.Retrocomision) : rowData.Retrocomision;
};
</script>

<style lang="scss" scoped>


.lupa {
  color: var(--text-success-default);
}

.detalle {
  color: var(--text-primary-default);
  cursor: pointer;
}
</style>